const features = [
  {
    title: "ระบบเช็คอิน-เช็คเอาท์",
    desc: "รองรับ GPS และกล้องถ่ายรูป ตรวจสอบจุดเช็คอิน บันทึกวันเวลาและพิกัด",
    icon: "📍",
  },
  {
    title: "การแจ้งเตือน (Push Notification)",
    desc: "แจ้งข่าวสารภายในองค์กร และตั้งค่าการแจ้งเตือนเฉพาะบุคคลได้",
    icon: "🔔",
  },
  {
    title: "เข้าสู่ระบบหลายรูปแบบ",
    desc: "WU PASS, PIN, และ Biometric (ลายนิ้วมือ/Face ID) พร้อมเริ่มสแกนอัตโนมัติ",
    icon: "🔐",
  },
  {
    title: "ปลอดภัยและควบคุมการเข้าถึง",
    desc: "มาตรการความปลอดภัยและการจัดการสิทธิ์เข้าถึงข้อมูล",
    icon: "🛡️",
  },
];

export function Features() {
  const items = features
    .map(
      (f) => `
        <div class="feature-item card">
            <div class="feature-icon">${f.icon}</div>
            <h3>${f.title}</h3>
            <p>${f.desc}</p>
        </div>
    `
    )
    .join("");

  return `
        <section class="section features" id="features">
            <div class="container">
            <h2 class="section-title">ฟีเจอร์หลัก</h2>
                <div class="features-grid">
                    ${items}
                </div>
            </div>
        </section>
    `;
}
